import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "../../../../../../library/src/lib/library.module";
import {GeneralModule} from "../general/general.module";
import {
  SalesClientIdentificationExpressKredicashComponent
} from "./sales-client-identification-express-kredicash.component";



@NgModule({
  declarations: [
    SalesClientIdentificationExpressKredicashComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimengModule,
    LibraryModule,
    GeneralModule
  ],
  exports: [
    SalesClientIdentificationExpressKredicashComponent
  ]
})
export class SalesClientIdentificationExpressKredicashModule { }
